<template>
  <div class="content-field--wrap">
    <v-text-field :value="internalValue"
                  :multiLine="multiLine"
                  :label="label"
                  :placeholder="placeholder"
                  :type="type"
                  :hint="hint"
                  :persistent-hint="persistentHint"
                  :error="hasValidationError"
                  :error-messages="errorMessages"
                  :disabled="disabled"
                  :readonly="readonly"
                  :maxlength="maxlength"
                  :append-icon="readonly ? 'block' : ''"
                  @input="onInput"
                  @change="onChange"
                  @focus="onFocus"
                  @blur="onBlur"
    >
    </v-text-field>
  </div>
</template>

<script>
import errorMessages from '@/modules/error-messages'
import { map, mergeDeepRight, values, isNil } from 'ramda'

export default {
  name: 'content-field',
  props: {
    multiLine: {
      type: Boolean
    },
    readonly: {
      type: Boolean,
      default: false
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    value: {
      type: null
    },
    type: {
      type: String
    },
    hint: {
      type: String
    },
    persistentHint: {
      type: Boolean,
      default: false
    },
    error: {
      type: Object,
      default: () => ({})
    },
    customErrorMessages: {
      type: Array,
      default: () => ([])
    },
    disabled: {
      type: Boolean
    },
    maxlength: {
      type: [String, Number]
    }
  },
  data () {
    return {
      internalValue: ''
    }
  },
  computed: {
    hasValidationError () {
      return this.error && this.error.$error
    },
    errorMessages () {
      if (this.error && !this.hasValidationError) {
        return []
      }
      const errorParams = []
      if (this.error.$params !== undefined && Object.keys(this.error.$params).length) {
        for (const param in this.error.$params) {
          if (this.error.$params.hasOwnProperty(param) && this.error[param] === false) {
            errorParams.push(param)
          }
        }
      }
      return this.generateErrors(errorParams)
    }
  },
  watch: {
    value (newVal) {
      if (this.internalValue !== newVal) {
        this.internalValue = newVal
      }
    }
  },
  methods: {
    onChange (e) {
      this.$emit('change', e)
    },
    onInput (e) {
      this.$emit('input', e)
    },
    onFocus (e) {
      if (this.error !== undefined) {
        if (this.error.$reset) {
          this.error.$reset()
        }
      }
      this.$emit('focus', e)
    },
    onBlur (e) {
      if (this.error !== undefined) {
        if (this.error.$touch) {
          this.error.$touch()
        }
      }
      this.$emit('blur', e)
    },
    generateErrors (errorParams = []) {
      let customObj = map(obj => ({type: obj.type, message: obj.message}), this.customErrorMessages)
      let errors = values(mergeDeepRight(errorMessages, customObj))
      const matchedErrors = errors.filter(m => errorParams.indexOf(m.type) > -1)
      return matchedErrors.length ? matchedErrors.map(e => e.message) : []
    }
  },
  beforeMount () {
    this.internalValue = isNil(this.value) ? '' : this.value
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/shared/ContentField/index.vue